export default __webpack_public_path__ + "static/media/team26.63d4d32a.JPG";